import React from 'react';

import block from 'propmods';

import { QuestionLink } from '../QuestionLink/QuestionLink';

import './Caption.scss';

interface CaptionProps {
    offsetTop?: boolean;
    offsetBottom?: boolean;
    wide?: boolean;
    url?: string;
}

const b = block('Caption');

const Caption: React.SFC<CaptionProps> = ({ children, url, offsetTop = true, offsetBottom = false, wide = false }) => (
    <span
        {...b({
            'offset-top': offsetTop,
            wide,
            'offset-bottom': offsetBottom,
        })}
    >
        <span {...b('text')}>{children}</span>
        {url && (
            <span {...b('link')}>
                <QuestionLink url={url} />
            </span>
        )}
    </span>
);

export default Caption;
